import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { basename } from '../../../config'

function BannerBlog() {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return (
    <Carousel
      activeIndex={index}
      onSelect={handleSelect}
      nextIcon=""
      prevIcon=""
      interval={3000}
    >
      <Carousel.Item>
        <img
          src={`/${basename}/Assets/Images/slide_one.jpg`}
          className="d-block carouselImage w-100"
          alt="slide_one"
        />
        <Carousel.Caption>
          <p>
            Book and track shipments from anywhere in the world to your front
            door.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          src={`/${basename}/Assets/Images/slide_two.jpg`}
          className="d-block carouselImage w-100"
          alt="slide_two"
        />
        <Carousel.Caption>
          <p>
            Access all shipping schedules for the world's major steamship lines
            and carriers.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          src={`/${basename}/Assets/Images/slide_three.jpg`}
          className="d-block carouselImage w-100"
          alt="slide_three"
        />
        <Carousel.Caption>
          <p>
            Read the latest news and updates in the logistics and shipping
            world.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          src={`/${basename}/Assets/Images/slide_four.jpg`}
          className="d-block carouselImage w-100"
          alt="slide_four"
        />
        <Carousel.Caption>
          <p>
            Enjoy the most advanced next-generation cargo tracking from start to
            finish.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          src={`/${basename}/Assets/Images/slide_five.jpg`}
          className="d-block carouselImage w-100"
          alt="slide_five"
        />
        <Carousel.Caption>
          <p>
            Choose what's important to you - delivery time, reduced costs, and
            more.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default BannerBlog;
